import html2canvas from "html2canvas";
import moment from "moment";
import ViewDetails from "../../Pages/DMS/Common/ViewDetails/ViewDetails";

//This function will download a screenshot a div with ref

export const downLoadScreenShot = (ref, scale, fileName, hideZoomControls) => {
  if (hideZoomControls) {
    let control = document.querySelector(".leaflet-control-zoom");
    control.setAttribute("data-html2canvas-ignore", "true");
  }
  html2canvas(ref.current, {
    useCORS: true,
    backgroundColor: null,
    scale: scale,
    windowHeight: ref.current.scrollHeight,
    windowWidth: ref.current.scrollWidth,
  }).then((canvas) => {
    const a = document.createElement("a");
    a.href = canvas.toDataURL();
    a.download = fileName;
    a.click();
  });
};

export const filterDate = (response, fieldName) => {
  response.forEach((record) => {
    if (record[fieldName]) {
      record[fieldName] = getFormattedDate(record[fieldName]);
    }
  });
  return response;
};

//This function will take date object as parameter and return the date DD/MM/YYYY
export const getFormattedDate = (date, format = "DD/MM/YYYY HH:mm:ss") =>
  moment(date).format(format);
//  export const getFormattedTableDate = (date) => moment(date).format("DD/MM/YYYY");
// // This function will convert the data into array of strings
export const getStringFormatData = (data) => {
  return data.map((item) => item.value).join(",");
};

export const getDRAttributeValue = (data,key)=>{
  if(data[key] && data[key] != null){
    return data[key]
  }
  else{
    return null;
  }
};

export const downloadFile = async (fileURL,fileName) => {
  let res = await fetch(fileURL, {
    method: 'GET',
    headers: {
      'Authorization': 'Bearer '+localStorage.getItem("auth_token")
    }
  });
  res.blob().then(function(content){
    const a = document.createElement('a');
    document.body.appendChild(a);
    const url = window.URL.createObjectURL(content);
    a.href = url;
    a.download = fileName;
    a.click();
  });
    
};

//This function is used for Append THe data of Images and Text

export const appendFormData = (data, formData, additionalExclusions = []) => {
  const defaultExclusions = ["registration_date", "deleted", "id"];
  const excludedKeys = [...defaultExclusions, ...additionalExclusions];

  for (const key in data) {
    if (excludedKeys.includes(key)) {
      // Skip this key if it's in the excludedKeys array
      continue;
    } else {
      formData.append(key, data[key]);
    }
  }
};

// This function will take submittedData and formConfig as parameter and
// return the catergoried data based on the tabs also adds the Registered On for the first tab.
export const getCategroisedFormData = (submittedData, configData, colNumb) => {
  console.log(submittedData, configData);
  const config = configData;
  const categorisedData = {};
  for (let i = 0; i < config.length; i++) {
    const section = config[i];
    const sectionData = [];
    for (let j = 0; j < section.fields.length; j++) {
      let field = section.fields[j];
      let fieldName = field?.name;
      let fieldValue = submittedData[fieldName];
      if (i === 0 && j === section.fields.length - 1) {
        sectionData.push({
          label: "Registered On",
          value: submittedData["registration_date"],
          type: "date",
        });
      }
      sectionData.push({
        label: field.label,
        value: fieldValue,
        type: field.type,
      });
    }
    categorisedData[section.name.toLowerCase()] = sectionData;
    section.component = <ViewDetails data={sectionData} columns={colNumb} />;
  }
  return config;
};

export const getCategroisedDataForPreview = (submittedData, configData, id) => {
  const config = configData;
  const categorisedData = {};
  for (const section of config) {
    const sectionData = [];
    for (const field of section.fields) {
      const fieldName = field.name;
      const fieldValue = submittedData[fieldName];
      sectionData.push({
        label: field.label,
        value: fieldValue,
        type: field.type,
      });
    }

    categorisedData[section.name.toLowerCase()] = sectionData;
    section.component = <ViewDetails data={sectionData} columns={3} id={id} />;
  }
  return config;
};

export const getExportedColumnsData = (columns, data) => {
  const exportedData = data.map((item) => {
    const exportedItem = {};
    columns.forEach((column) => {
      if (item.hasOwnProperty(column.key)) {
        // Handle activeStatus field for Bank Management
        if (column.key === "activeStatus") {
          exportedItem[column.label] = item[column.key] === true ? "Active" : "Inactive";
        } 
        // Handle null/empty values
        else {
          exportedItem[column.label] = isNotNullOrEmptyOrUndefined(item[column.key]) 
            ? item[column.key] 
            : "NA";
        }
      } else {
        // If the property doesn't exist, set to "NA"
        exportedItem[column.label] = "NA";
      }
    });
    return exportedItem;
  });
  return exportedData;
};

export const setValuesFromGetValues = (fieldNames, setValue, getValues) => {
  console.log("fieldNames=", fieldNames);
  fieldNames.forEach((fieldName) => {
    const valueToSet = getValues(fieldName); // Get the value from getValues
    setValue(fieldName, valueToSet); // Set the value using setValue
  });
};

export function isNotNullOrEmptyOrUndefined(value) {
  return value !== null && value !== undefined && value !== "";
}


export const ConfirmationModal = ({ isOpen, onClose, onConfirm, title, message }) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "0.75rem",
          padding: "1.5rem",
          maxWidth: "400px",
          width: "90%",
          boxShadow: "0 10px 25px rgba(0, 0, 0, 0.25)",
          transform: "scale(1)",
          animation: "modalFadeIn 0.2s ease-out",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ marginBottom: "1rem" }}>
          <h3
            style={{
              fontSize: "1.125rem",
              fontWeight: "600",
              color: "#1f2937",
              marginBottom: "0.5rem",
            }}
          >
            {title}
          </h3>
          <p
            style={{
              fontSize: "0.875rem",
              color: "#6b7280",
              lineHeight: "1.5",
              margin: 0,
            }}
          >
            {message}
          </p>
        </div>
        
        <div
          style={{
            display: "flex",
            gap: "0.75rem",
            justifyContent: "flex-end",
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "0.5rem 1rem",
              backgroundColor: "#f3f4f6",
              color: "#374151",
              borderRadius: "0.375rem",
              border: "none",
              cursor: "pointer",
              fontSize: "0.875rem",
              fontWeight: "500",
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = "#e5e7eb";
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = "#f3f4f6";
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: "0.5rem 1rem",
              backgroundColor: "#ef4444",
              color: "white",
              borderRadius: "0.375rem",
              border: "none",
              cursor: "pointer",
              fontSize: "0.875rem",
              fontWeight: "500",
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = "#dc2626";
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = "#ef4444";
            }}
          >
            Remove Join
          </button>
        </div>
      </div>
      
      <style jsx>{`
        @keyframes modalFadeIn {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
      `}</style>
    </div>
  );
};